import { StoryDetail } from '@app/utils/models/story-detail.model';
import { Story } from '@app/utils/models/story.model';

// Flags the story's bookmark in a list.
export function setStoryBookmark(stories: Story[], slug: string, isBookmarked: boolean): Story[] {
  return stories.map(story => (story.slug === slug ? { ...story, isBookmarked } : story));
}

// A newly bookmarked story goes first in the saved stories; an unbookmarked one leaves them.
export function setBookmarkedStory(
  bookmarkedStories: Story[],
  slug: string,
  isBookmarked: boolean,
  story: Story | undefined,
): Story[] {
  const otherBookmarkedStories = bookmarkedStories.filter(bookmarkedStory => bookmarkedStory.slug !== slug);
  return isBookmarked && story ? [{ ...story, isBookmarked }, ...otherBookmarkedStories] : otherBookmarkedStories;
}

// Flags the bookmark of the open story, when it is that story.
export function setStoryDetailBookmark(
  storyDetail: StoryDetail | null,
  slug: string,
  isBookmarked: boolean,
): StoryDetail | null {
  return storyDetail?.slug === slug ? { ...storyDetail, isBookmarked } : storyDetail;
}
